// extracted by mini-css-extract-plugin
export default {"button-submit-title":"ButtonSubmit_button-submit-title__AXqgh"};